document.addEventListener('DOMContentLoaded', function() {
  function pgmShowNextReview() {
    const pgmCurrentReview = document.querySelector('.pmg-review.active');
    let pgmNextReview = pgmCurrentReview.nextElementSibling;
    // Check if next review exists, otherwise loop back to the first one
    if (!pgmNextReview || !pgmNextReview.classList.contains('pmg-review')) {
      pgmNextReview = document.querySelector('.pmg-review');
    }
    // Fade out the current review and fade in the next one
    pgmCurrentReview.classList.remove('active');
    pgmCurrentReview.style.opacity = 0;

    setTimeout(function() {
      pgmCurrentReview.style.display = 'none';
      pgmNextReview.style.display = 'block';
      pgmNextReview.style.opacity = 1;
      pgmNextReview.classList.add('active');
    }, 600);
  }
  // Initial setup
  const pgmReviews = document.querySelectorAll('.pmg-review');
  pgmReviews.forEach(pgmReview => {
    pgmReview.style.display = 'none';
    pgmReview.style.opacity = 0;
  });
  const pgmActiveReview = document.querySelector('.pmg-review.active');
  if (pgmActiveReview) {
    pgmActiveReview.style.display = 'block';
    pgmActiveReview.style.opacity = 1;
  }
  setInterval(pgmShowNextReview, 5000);
});

document.addEventListener('DOMContentLoaded', function() {
  function showNextReview() {
    const currentReview = document.querySelector('.pd-review.active');
    let nextReview = currentReview.nextElementSibling;
    // Check if next review exists, otherwise loop back to the first one
    if (!nextReview || !nextReview.classList.contains('pd-review')) {
      nextReview = document.querySelector('.pd-review');
    }
    // Fade out the current review and fade in the next one
    currentReview.classList.remove('active');
    currentReview.style.opacity = 0;

    setTimeout(function() {
      currentReview.style.display = 'none';
      nextReview.style.display = 'block';
      nextReview.style.opacity = 1;
      nextReview.classList.add('active');
    }, 600);
  }
  // Initial setup
  const reviews = document.querySelectorAll('.pd-review');
  reviews.forEach(review => {
    review.style.display = 'none';
    review.style.opacity = 0;
  });
  const activeReview = document.querySelector('.pd-review.active');
  if (activeReview) {
    activeReview.style.display = 'block';
    activeReview.style.opacity = 1;
  }
  setInterval(showNextReview, 5000);
});

document.addEventListener("DOMContentLoaded", function() {
  const videoContainers = document.querySelectorAll(".videoProd");

  videoContainers.forEach(function(container) {
    const video = container.querySelector(".videoProdItem");
    const playButton = container.querySelector(".videoProdPlay");

    container.addEventListener("click", function() {
      // Toggle play/pause for the clicked video
      if (video.paused) {
        videoContainers.forEach(function(otherContainer) {
          const otherVideo = otherContainer.querySelector(".videoProdItem");
          const otherPlayButton = otherContainer.querySelector(".videoProdPlay");

          if (otherVideo !== video) {
            otherVideo.pause();
            otherContainer.classList.remove("active");
            otherPlayButton.style.display = "block"; // Show play icon on other videos
          }
        });
        video.play();
        container.classList.add("active");
        playButton.style.display = "none"; // Hide play icon
      } else {
        video.pause();
        container.classList.remove("active");
        playButton.style.display = "block"; // Show play icon
      }
    });
    video.addEventListener("ended", function() {
      container.classList.remove("active");
      playButton.style.display = "block"; // Show play icon when video ends
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const faqHeaders = document.querySelectorAll('.ff-item');

  faqHeaders.forEach(header => {
    const question = header.querySelector('.ff-header');
    const icon = header.querySelector('.ff-icon');
    const answer = header.querySelector('.ff-answer');

    // Ensure the active FAQ is open by default
    if (header.classList.contains('active')) {
      icon.textContent = "-"; // Change the icon for active FAQ
      answer.style.display = 'block'; // Show the answer for active FAQ
    } else {
      icon.textContent = "+"; // Default icon for inactive FAQ
      answer.style.display = 'none'; // Hide the answer for inactive FAQ
    }

    question.addEventListener('click', function () {
      // Close all items except the clicked one
      faqHeaders.forEach(item => {
        if (item !== header) {
          item.classList.remove('active');
          const itemIcon = item.querySelector('.ff-icon');
          const itemAnswer = item.querySelector('.ff-answer');
          itemIcon.textContent = "+";
          itemAnswer.style.display = 'none';
        }
      });

      // Toggle the clicked item
      const isActive = header.classList.toggle('active');
      icon.textContent = isActive ? "-" : "+";
      answer.style.display = isActive ? 'block' : 'none';

      // Smooth scroll to the clicked item with precise offset
      if (isActive) {
        const headerOffset = 20; // Adjust this value for the desired offset from the top
        const headerPosition = header.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = headerPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    });
  });
});

//hide qty field from design-1 product page
document.addEventListener("DOMContentLoaded", function () {
  const design_1_product_id = document.querySelector('input[name="product-id"]');
  if (design_1_product_id) {
    if(design_1_product_id.value == 7444745977879){
      console.log("qty. field hidden");
      const quantityField = document.getElementById("Quantity-Form-template--21754279919639__main");
      if (quantityField) {
          quantityField.style.display = "none";
      }
    } else { console.log("qty. field display"); }
  }  
})


// document.addEventListener('DOMContentLoaded', function () {
//   // Select the quantity input field using its name attribute
//   const quantityInput = document.querySelector('input[name="quantity"]');
//   if (!quantityInput) {
//     console.error('Quantity input field not found.');
//     return;
//   }

//   // Buttons for quantity selection
//   const oneBottleBtn = document.querySelector('#one-bottle');
//   const twoBottlesBtn = document.querySelector('#two-bottles');
//   const fourBottlesBtn = document.querySelector('#four-bottles');

//   // Ensure buttons exist
//   if (!oneBottleBtn || !twoBottlesBtn || !fourBottlesBtn) {
//     console.error('One or more buttons not found.');
//     return;
//   }

//   // Set the first button (oneBottleBtn) as active by default
//   setActiveButton(oneBottleBtn);
//   updateQuantity(1);

//   // Add click event listeners to the buttons
//   oneBottleBtn.addEventListener('click', function () {
//     updateQuantity(1);
//     setActiveButton(this);
//   });

//   twoBottlesBtn.addEventListener('click', function () {
//     updateQuantity(2);
//     setActiveButton(this);
//   });

//   fourBottlesBtn.addEventListener('click', function () {
//     updateQuantity(4);
//     setActiveButton(this);
//   });

//   // Function to update the quantity value
//   function updateQuantity(qty) {
//     if (quantityInput) {
//       quantityInput.value = qty; // Set the input value
//       triggerInputChange(quantityInput); // Trigger Shopify's change event
//     }
//   }

//   // Function to trigger the input change event
//   function triggerInputChange(input) {
//     const event = new Event('change', { bubbles: true });
//     input.dispatchEvent(event); // Notify Shopify about the quantity change
//   }

//   // Function to visually highlight the active button
//   function setActiveButton(activeButton) {
//     // Remove the active class from all buttons
//     document.querySelectorAll('.qty-button').forEach(function (btn) {
//       btn.classList.remove('active');
//     });
//     // Add the active class to the clicked button
//     activeButton.classList.add('active');
//   }
// });
// JavaScript code


// document.addEventListener('DOMContentLoaded', function () {
//   // Select the quantity input field using its name attribute
//   const quantityInput = document.querySelector('input[name="quantity"]');
//   if (!quantityInput) {
//     console.error('Quantity input field not found.');
//     return;
//   }

//   // Buttons for quantity selection
//   const oneBottleBtn = document.querySelector('#one-bottle');
//   const twoBottlesBtn = document.querySelector('#two-bottles');
//   const fourBottlesBtn = document.querySelector('#four-bottles');

//   // Ensure buttons exist
//   if (!oneBottleBtn || !twoBottlesBtn || !fourBottlesBtn) {
//     console.error('One or more buttons not found.');
//     return;
//   }

//   // Set the first button (oneBottleBtn) as active by default
//   setActiveButton(oneBottleBtn);
//   updateQuantity(1);

//   // Add click event listeners to the buttons
//   oneBottleBtn.addEventListener('click', function () {
//     updateQuantity(1);
//     setActiveButton(this);
//   });

//   twoBottlesBtn.addEventListener('click', function () {
//     updateQuantity(2);
//     setActiveButton(this);
//   });

//   fourBottlesBtn.addEventListener('click', function () {
//     updateQuantity(4);
//     setActiveButton(this);
//   });

//   // Function to update the quantity value
//   function updateQuantity(qty) {
//     if (quantityInput) {
//       quantityInput.value = qty; // Set the input value
//       triggerInputChange(quantityInput); // Trigger Shopify's change event
//     }
//   }

//   // Function to trigger the input change event
//   function triggerInputChange(input) {
//     const event = new Event('change', { bubbles: true });
//     input.dispatchEvent(event); // Notify Shopify about the quantity change
//   }

//   // Function to visually highlight the active button's parent div
//   function setActiveButton(activeButton) {
//     // Remove the active class from all bottle_item divs
//     document.querySelectorAll('.bottle_item').forEach(function (item) {
//       item.classList.remove('active');
//     });
//     // Add the active class to the parent div of the clicked button
//     activeButton.closest('.bottle_item').classList.add('active');
//   }
// });